module.exports = __webpack_public_path__ + "static/media/apple_app_store_badge.2928664f.svg";